import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { Total, PieChartContainer } from './styles';

const chartProps = {
  width: 128,
  innerRadius: 48,
  outerRadius: 62,
};

export const Chart = ({ osData, showTotal = true }) => {
  let totalHoras = 0;
  let totalMinutos = 0;

  osData.forEach(item => {
    const value = item.value || 0;
    const horas = Math.floor(value);
    const minutos = Math.round((value - horas) * 100);

    totalHoras += horas;
    totalMinutos += minutos;
  });

  const horasExtras = Math.floor(totalMinutos / 60);
  totalHoras += horasExtras;
  totalMinutos = totalMinutos % 60;

  const totalGeral = (totalHoras + totalMinutos / 100).toFixed(2);

  return (
    <PieChartContainer>
      <PieChart className="pie-chart" width={chartProps.width} height={chartProps.width}>
        <Pie
          data={osData}
          innerRadius={chartProps.innerRadius}
          outerRadius={chartProps.outerRadius}
          paddingAngle={0}
          stroke="null"
          dataKey="value"
        >
          {osData.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.fill} />
          ))}
        </Pie>
      </PieChart>
      {showTotal && (
        <Total>
          <span className="total">Total</span>
          <span className="value">{totalGeral}h</span>
        </Total>
      )}
    </PieChartContainer>
  );
};
